import { CustomFieldListItemProps } from "@/components/custom-field/list-item/custom-field-list-item.type.ts";
import useFormatter from "@/hooks/use-formatter.hook.ts";
import { getEmployeePositionTitle } from "@/types/employees/employee-position.types.ts";
import { getEmployeeAvatarUrl } from "@/types/employees/employee.types.ts";
import { ListItem, Stack } from "@skailer-com/uikit";
import { Link } from "react-router-dom";

export function CustomFieldListItemEmployeeReference({
  field,
  fieldValue,
  label,
}: CustomFieldListItemProps) {
  const { renderEmployeeName } = useFormatter();

  return (
    <ListItem
      preTitle={label ?? field.title}
      titleSlot={
        <Stack>
          {fieldValue?.value_employees ? (
            fieldValue.value_employees.map((employeeItem) => (
              <Link
                key={`person-employee-${employeeItem.id}`}
                to={`/employees/${employeeItem.id}`}
                className={"pt-2"}
              >
                <ListItem
                  preTitle={renderEmployeeName(employeeItem)}
                  title={getEmployeePositionTitle(employeeItem)}
                  avatarUrl={getEmployeeAvatarUrl(employeeItem, "sm")}
                  forceShowAvatar={true}
                  emphasis={"top"}
                  behavior={"card"}
                />
              </Link>
            ))
          ) : (
            <ListItem title={"-"} forceShowAvatar={true} behavior={"card"} />
          )}
        </Stack>
      }
    />
  );
}
